import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Seo } from "../components/Seo";
import { PageHeader } from "../components/PageHeader";
import { SERVICES } from "../data/site";

export default function ServicesPage({ onQuoteClick }) {
  return (
    <div data-testid="services-page">
      <Seo title="Services — IDEAL ENTERPRISES" description="14 service verticals across MDPE, steel pipelines, PNG, HDD, and utility infrastructure." />
      <PageHeader
        overline="WHAT WE BUILD"
        title="14 specialist service verticals across the CGD &amp; utility value chain."
        subtitle="From route survey to first-fire, we own the full execution stack — engineered, documented, audited."
        bgImage="https://images.pexels.com/photos/3818947/pexels-photo-3818947.jpeg"
      />

      <section className="py-20 bg-white" data-testid="services-grid">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 grid-borders border-t border-l border-slate-200">
            {SERVICES.map((s, i) => {
              const Icon = s.icon;
              return (
                <motion.div
                  key={s.slug}
                  initial={{ opacity: 0, y: 12 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-50px" }}
                  transition={{ duration: 0.4, delay: (i % 3) * 0.05 }}
                >
                  <Link
                    to={`/services/${s.slug}`}
                    data-testid={`services-page-card-${s.slug}`}
                    className="group block p-8 h-full hover:bg-slate-50 transition-colors relative"
                  >
                    <span className="absolute top-0 left-0 right-0 h-0.5 bg-brand-orange scale-x-0 group-hover:scale-x-100 origin-left transition-transform" />
                    <div className="flex items-center justify-between">
                      <span className="font-mono-tech text-[11px] text-slate-400">SERVICE / {(i+1).toString().padStart(2, "0")}</span>
                      <Icon size={26} className="text-brand-blue group-hover:text-brand-orange transition-colors" />
                    </div>
                    <h3 className="font-heading font-bold text-xl text-brand-blue mt-6">{s.title}</h3>
                    <p className="text-sm text-slate-600 mt-3 leading-relaxed">{s.short}</p>
                    <span className="inline-flex items-center gap-1 mt-6 text-xs font-semibold text-brand-orange">
                      View details <ArrowRight size={12} />
                    </span>
                  </Link>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#F8F9FA] border-t border-slate-200">
        <div className="max-w-5xl mx-auto px-6 lg:px-10 text-center">
          <p className="overline">Need a custom scope?</p>
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-brand-blue mt-3">
            Tell us about your package — we'll engineer a solution.
          </h2>
          <button
            onClick={onQuoteClick}
            data-testid="services-page-quote"
            className="mt-8 bg-brand-orange text-white px-8 py-4 font-semibold btn-lift hover:bg-orange-600"
          >
            Request a Quote
          </button>
        </div>
      </section>
    </div>
  );
}
